import React, { useMemo } from "react";
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableRow,
  TableCell,
  Paper,
  IconButton,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import MyButton from "./MyButton";

const MyTable = ({ myStore, onClick, onRemoveRow }) => {
  const rows = useMemo(() => {
    if (!myStore) return [];
    if (Array.isArray(myStore)) return myStore.map((r) => ({ key: r.item, row: r }));
    if (typeof myStore === "object") return Object.entries(myStore).map(([key, row]) => ({ key, row }));
    return [];
  }, [myStore]);

  if (rows.length === 0) return null;

  return (
    <Box sx={{ flexDirection: "column", gap: 2, alignItems: "center" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "1px dashed grey",
          mt: 1,
          p: 1,
        }}
      >
        <TableContainer component={Paper}>
          <Table sx={{ maxWidth: 400 }} size="small" aria-label="index table">
            <TableBody>
              {rows.map(({ key, row }) => (
                <TableRow key={key ?? row.item}>
                  <TableCell align="center">{row.item}</TableCell>
                  <TableCell align="center">{row.value}</TableCell>
                  {onRemoveRow && (
                    <TableCell align="center" padding="none">
                      <IconButton
                        size="small"
                        onClick={() => onRemoveRow(key)}
                        sx={{ color: "error.main" }}
                      >
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <MyButton onClick={onClick} />
    </Box>
  );
};

export default MyTable;
